import { NavLink, Outlet, useLocation } from "react-router-dom";
import Navbar from "../../components/Landing/components/Navbar/Navbar";
import classes from "./TermsAndPolicyLayout.module.css";
import Footer from "../../components/Landing/components/Footer/Footer";

const TermsAndPolicyLayout = () => {
  let { pathname } = useLocation();
  return (
    <>
      <Navbar />

      <main>
        <div className={classes.header}>
          <NavLink to="/terms-of-service">Terms of Use</NavLink>
          <NavLink to="/privacy-policy"> Privacy Policy</NavLink>
          <hr />
          <h2>{pathname === "/terms-of-service" && "Terms of service"}</h2>
          <h2>{pathname === "/privacy-policy" && "Privacy Policy"}</h2>
        </div>
        <div className={classes.main}>
          <Outlet />
        </div>
      </main>
      <br />
      <br />
      <Footer />
    </>
  );
};

export default TermsAndPolicyLayout;
